import styled, { css } from 'styled-components';

export const NextGenHeaderStyled = styled.header`
  ${({ theme }) => {
    const { media, colors } = theme;

    return css`
      align-items: center;
      background: ${colors.primary.white};
      display: flex;
      padding: 20px 16px;
      position: relative;
      width: 100%;

      ${media.tablet.up} {
        padding: 25px;
      }

      .icon--frontier-logo {
        color: ${colors.primary.red};
      }

      .container {
        align-items: center;
        display: flex;
        justify-content: space-between;
        position: relative;
        width: 100%;
        max-width: 1100px;

        ${media.tablet.up} {
          justify-content: start;
          padding: 0;
        }

        .eero-logo {
          padding-left: 32px;
        }
      }

      .header__left-content {
        display: flex;
        align-items: center;
        gap: 40px;
      }

      .header__info-container {
        display: flex;
        align-items: center;

        ${media.mobile.down} {
          flex-direction: column;
          align-items: flex-end;
        }
      }

      .header__right-content {
        display: flex;
        align-items: center;
        gap: 20px;

        ${media.tablet.up} {
          margin-left: auto;
        }

        ${media.tablet.down} {
          flex-direction: column;
          align-items: flex-end;
          gap: 0;
        }
      }

      .edit-address--desktop {
        ${media.mobile.down} {
          display: none;
        }
      }

      .edit-address--mobile {
        display: none;

        ${media.mobile.down} {
          display: block;
          order: 0;
        }
      }

      .icon--fill-chevron-right {
        width: 20px;
        height: 20px;
      }

      .btn-skip {
        display: flex;
        align-items: center;
        gap: 6px;
        margin-left: auto;
        background: none;
        border: none;
        font-size: 0.875rem;
        font-weight: 700;
        text-decoration: underline;
        text-transform: uppercase;
        cursor: pointer;
      }

      .edit-address {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 8px;
        margin-bottom: 0px !important;

        &__title {
          ${media.mobile.down} {
            display: none !important;
          }
          font-size: 14px !important;
          font-weight: 400 !important;
          line-height: 18px !important!;
          color: black !important;
          font-color: black !important;
          margin: 0 !important;
          svg {
            height: 14.5px !important;
            width: 12px !important;
            path {
              fill: black !important;
            }
          }
        }
        &__button {
          font-size: 14px !important;
          font-weight: 400 !important;
          line-height: 18px !important!;
          color: black !important;
        }

        span {
          color: black !important;
          text-decoration: none;
          font-weight: 400 !important;
          text-decoration: underline !important;
        }
      }

      .quoteNumber {
        display: flex;
        align-items: center;
        gap: 8px;
        font-size: 14px;
        font-weight: 400;
        line-height: 18px;

        ${media.mobile.down} {
          margin-top: 8px;
          order: 1;
        }
      }

      .claim-rewards-toggle {
        ${media.mobile.down} {
          margin-top: 8px;
          order: 2;
        }

        p {
          margin: 0;
          font-size: 14px;
          font-weight: 400;
          line-height: 18px;
          white-space: nowrap;
        }
      }
    `;
  }};
`;
